/**
 * assets/koishow-intro.js
 * Gedrag van sections/koishow-intro.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  var el=document.querySelector('[data-kswi-teller]'); if(!el) return;
  var eind=new Date(el.getAttribute('data-deadline')).getTime();
  var tick=function(){
    var over=eind-Date.now(); if(over<=0){ el.textContent='De actie is gesloten.'; return; }
    var d=Math.floor(over/86400000), u=Math.floor(over%86400000/3600000);
    el.textContent='Nog '+(d>0?d+(d===1?' dag':' dagen'):'')+(d>0&&u>0?' en ':'')+(u>0?u+' uur':'')+' om te bestellen';
  };
  tick(); setInterval(tick,60000);
})();
